export default __webpack_public_path__ + "static/media/bun_top.56323709.svg";